import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
    return twMerge(clsx(inputs));
}

export const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

// API helper with auth
export async function apiRequest(endpoint, options = {}) {
    const token = localStorage.getItem('auth_token');
    const headers = {
        'Content-Type': 'application/json',
        ...options.headers,
    };
    
    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }
    
    try {
        const response = await fetch(`${API_URL}${endpoint}`, {
            ...options,
            headers,
            credentials: 'include',
        });
        
        if (!response.ok) {
            let errorMessage = 'Une erreur est survenue';
            try {
                const error = await response.json();
                errorMessage = error.detail || errorMessage;
            } catch {
                // Response wasn't JSON
            }
            throw new Error(errorMessage);
        }
        
        return response.json();
    } catch (error) {
        if (error instanceof Error) {
            throw error;
        }
        throw new Error('Erreur réseau');
    }
}

// Format price
export function formatPrice(price) {
    return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR'
    }).format(price);
}

// Format date
export function formatDate(dateString) {
    return new Intl.DateTimeFormat('fr-FR', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    }).format(new Date(dateString));
}

// Get status color
export function getStatusColor(status) {
    switch (status) {
        case 'ideal':
            return 'text-emerald-500 bg-emerald-500/10';
        case 'low':
        case 'high':
            return 'text-amber-500 bg-amber-500/10';
        case 'critical_low':
        case 'critical_high':
            return 'text-red-500 bg-red-500/10';
        default:
            return 'text-muted-foreground bg-muted';
    }
}

// Get status label
export function getStatusLabel(status) {
    switch (status) {
        case 'ideal': return 'Idéal';
        case 'low': return 'Bas';
        case 'high': return 'Élevé';
        case 'critical_low': return 'Critique (bas)';
        case 'critical_high': return 'Critique (élevé)';
        default: return status;
    }
}
